module.exports = "https://static.wmbcdn.com/uniweb/images/15da1f54e08818941c3ec11c8a204f17.webp";